<template>
  <sidepanel
    title="Test results"
    :wide="true"
    id="panel-view-test"
    @open="init"
    @close="reset"
    :processing="processing"
  >
    <div v-if="test">
      <template v-if="test.status === 'completed'">
        <table>
          <tr>
            <td>Creation date</td>
            <td>{{ test.created | date }}</td>
          </tr>
          <tr>
            <td>Last updated</td>
            <td>{{ test.updated | date }}</td>
          </tr>
          <tr>
            <td colspan="2"><strong>Results</strong></td>
          </tr>
          <tr
            v-for="(result, index) in test.kit.markers"
            :key="'result-' + index"
          >
            <td>{{ result.title }}</td>
            <td>{{ result.value }} {{ result.unit }}</td>
          </tr>
        </table>
      </template>

      <div v-else-if="test.status === 'error'">
        Test failed. Read error description in the test log.
      </div>
      <div v-else>
        Results not ready yet...
      </div>
      <TestLog :log="test.log" />
      <div class="horiz meta-actions">
        <button @click="deleteTest(test.id)" class="icon">
          <v-icon name="trash" />
        </button>
        <button @click="init" class="icon">
          <v-icon name="sync-alt" />
        </button>
        <button
          @click="addPanel('panel-edit-test', { testId: test.id })"
          class="icon"
        >
          <v-icon name="pencil-alt" />
        </button>
        <router-link
          tag="button"
          class="icon"
          :to="'/clients/results/' + test.clientId"
          ><v-icon name="eye"
        /></router-link>
      </div>
    </div>
  </sidepanel>
</template>
<script>
import TestLog from "./TestLog";

export default {
  data() {
    return {
      processing: false,
      test: null
    };
  },
  props: {
    prevPanelInit: {
      type: Function,
      required: false
    }
  },
  components: { TestLog },
  methods: {
    async init() {
      this.processing = true;
      const payload = this.$store.getters.sidepanel("panel-view-test").payload;
      const test = await this.$store.dispatch("TestsStore/get", payload);
      this.test = test;
      this.processing = false;
    },
    reset() {
      this.test = null;
    },
    async deleteTest(testId) {
      if (!confirm("Delete this test?")) return;
      await this.$store.dispatch("TestsStore/delete", testId);

      // Reload previous panel
      if (this.prevPanelInit) this.prevPanelInit();
      this.removePanel();
    }
  }
};
</script>

<style scoped lang="less">
@import "../styles/vars";
.meta-actions {
  margin-top: @h2;
}
</style>
